module.exports = __webpack_public_path__ + "static/media/job-icon.2a131977.svg";